import { parseHash } from '../router/route.js';

/** 外部リンクの許可先（docs/spec/lesson-format.md §5.4）。サブドメインは不可。 */
export const EXTERNAL_LINK_HOSTS: readonly string[] = ['swift.inductor.dev', 'atcoder.jp'];

export interface LessonLinkTarget {
  href: string;
  /** true なら target="_blank" rel="noopener noreferrer" で描き、外部サイトの印を付ける。 */
  external: boolean;
}

/**
 * レッスン本文のリンク先を確かめる（§5.4）。許可しないものは null。
 * parse（ビルド時）と描画（ブラウザ）の両方がこの関数を使う。描画側は null なら文字だけを描く。
 */
export function lessonLinkTarget(url: string): LessonLinkTarget | null {
  if (url === '') return null;
  if (url.startsWith('#/')) {
    return parseHash(url).name === 'not-found' ? null : { href: url, external: false };
  }
  // 絶対 URL だけを受ける（//host、/path、相対パスは new URL が例外を投げる）。
  if (!url.startsWith('https://')) return null;
  let u: URL;
  try {
    u = new URL(url);
  } catch {
    return null;
  }
  if (u.protocol !== 'https:' || u.port !== '' || u.username !== '' || u.password !== '') {
    return null;
  }
  if (!EXTERNAL_LINK_HOSTS.includes(u.hostname)) return null;
  return { href: u.href, external: true };
}
